module.exports = __webpack_public_path__ + "fbda83e.woff";